import { PropsWithChildren } from "react";

import { styled } from "@linaria/react";

import { DROPZONE_TABLE_VIEW_COLUMN_WIDTH_MAP } from "@/pages/sources/components/dropzone/constants";
import { DropzoneTableViewColumn } from "@/pages/sources/components/dropzone/types";

interface DropzoneWidgetTableCellProps {
  column: DropzoneTableViewColumn;
}

const DropzoneWidgetTableCellWrapper = styled.div<{ $width?: number }>`
  flex: ${({ $width }) => ($width ? "none" : "1")};
  width: ${({ $width }) => ($width ? `${$width}px` : "auto")};
  min-width: ${({ $width }) => ($width ? `${$width}px` : "0")};
  overflow: hidden;
`;

const DropzoneWidgetTableCell = ({
  children,
  column,
}: PropsWithChildren<DropzoneWidgetTableCellProps>) => {
  const width = DROPZONE_TABLE_VIEW_COLUMN_WIDTH_MAP[column];

  return <DropzoneWidgetTableCellWrapper $width={width}>{children}</DropzoneWidgetTableCellWrapper>;
};

export default DropzoneWidgetTableCell;
